export default {
  noAddress: "Sin dirección",
  title: "Estructuras",
  subtitle: "Todas las estructuras de la plataforma",
  searchPlaceholder: "Buscar por estructura o propietario...",
  loadError: "No se pudieron cargar las estructuras",
  retry: "Reintentar",
  empty: "Ninguna estructura coincide con los filtros.",
  openRowAria: "Abrir estructura {{name}}",
  filters: {
    status: "Estado",
    statusAll: "Todas",
    statusActive: "Activas",
    statusInactive: "Inactivas",
  },
  columns: {
    name: "Estructura",
    owner: "Propietario",
    commission: "Comisión",
  },
} as const;
